import { useSelector } from "react-redux";

export default function useTourneyActiveGames(tournamentId) {
  const games = useSelector((state) => state.gameTable.games);
  let isAlreadyActiveTableDetails = null;

  Object.values(games).forEach((eachGame) => {
    if (
      eachGame.gameDefinition.tourneyId === tournamentId &&
      !eachGame.watchPlayer
    ) {
      isAlreadyActiveTableDetails = eachGame;
    }
  });

  return isAlreadyActiveTableDetails;
}
